import axios from 'axios'
import router from '../../router'

const state = {
  // sampleData: ''
  userLogin: '',
  userPwTran: '',
  userSelfPwTran: '',
  userMenu: '',
  userPrivate: '',
  downCount: ''
}

const getters = {
  getUserLogin (state) {
    return state.userLogin
  },
  getUserPwTran (state) {
    return state.userPwTran
  },
  getUserSelfPwTran (state) {
    return state.userSelfPwTran
  },
  getUserMenu (state) {
    return state.userMenu
  },
  getUserPrivate (state) {
    return state.userPrivate
  },
  getDownCount (state) {
    return state.downCount
  }
}

const mutations = {
  setUserLogin (state, payload) {
    state.userLogin = payload
  },
  setUserPwTran (state, payload) {
    state.userPwTran = payload
  },
  setUserSelfPwTran (state, payload) {
    state.userSelfPwTran = payload
  },
  setUserMenu (state, payload) {
    state.userMenu = payload
  },
  setUserPrivate (state, payload) {
    state.userPrivate = payload
  },
  setDownCount (state, payload) {
    state.downCount = payload
  },
}

const actions = {
  apiLoginData (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/login', payload)
        .then((response) => {
          // console.log(response.data)
          // console.log(JSON.stringify(response))
          // console.log(response.data.userInfo)
          context.commit('setUserLogin', response.data)
          resolve()
        })
        .catch((error) => {
          // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
          // console.log('error  = ' + error.message)
          // console.log(JSON.stringify(error))
          reject(error.message)
          alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
        })
    })
  },
  apiUserPwTran (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/updateUser', payload)
        .then((response) => {
          context.commit('setUserPwTran', response.data)
          resolve()
        })
        .catch((error) => {
          // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
          // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
          if (error.response.status === 410) {
            alert('세션이 만료되어 로그인 페이지로 이동합니다.')
            sessionStorage.clear()
            router.replace('/')
          }else{
            // console.log('error  = ' + error.message)
            // console.log(JSON.stringify(error))
            reject(error)
            // console.log('error.response.status = ' + error.response.status)
          }
          // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
        })
    })
  },
  apiUserSelfPwTran (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/updateUser', payload)
        .then((response) => {
          context.commit('setUserSelfPwTran', response.data)
          resolve()
        })
        .catch((error) => {
          // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
          if (error.response.status === 410) {
            alert('세션이 만료되어 로그인 페이지로 이동합니다.')
            sessionStorage.clear()
            router.replace('/')
          }else{
            // console.log('error  = ' + error.message)
            // console.log(JSON.stringify(error))
            reject(error)
            // console.log('error.response.status = ' + error.response.status)
          }
          // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
        })
    })
  },
  apiUserMenu (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/menuByRoleTreeSelect', payload)
        .then((response) => {
          context.commit('setUserMenu', response.data)
          resolve()
        })
        .catch((error) => {
          // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
          if (error.response.status === 410) {
            alert('세션이 만료되어 로그인 페이지로 이동합니다.')
            sessionStorage.clear()
            router.replace('/')
          }else{
            // console.log('error  = ' + error.message)
            // console.log(JSON.stringify(error))
            reject(error)
            // console.log('error.response.status = ' + error.response.status)
          }
          // alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
        })
    })
  },
  updateUser (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/updateUser', payload)
        .then((response) => {
          // console.log(response)
          // console.log(JSON.stringify(response))
          // console.log(response.data.userInfo)
          context.commit('setUserPrivate', response.data)
          resolve()
        })
        .catch((error) => {
          // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
          // console.log('error  = ' + error.message)
          // console.log(JSON.stringify(error))
          reject(error.message)
          alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
        })
    })
  },
  apiFileLog (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/actFileLog', payload)
        .then((response) => {
          // console.log(response)
          // console.log(JSON.stringify(response))
          // console.log(response.data.userInfo)
          context.commit('setDownCount', response.data)
          resolve()
        })
        .catch((error) => {
          // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
          // console.log('error  = ' + error.message)
          // console.log(JSON.stringify(error))
          reject(error.message)
          alert('ErrorCode = ' + error.response.status + ' / ' + error.message)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
